import {connect} from 'react-redux';
import {IReduxStoreState} from '../../@interfaces';
import AuthLogout from '../../../views/auth/AuthLogout';
import {clearUserRequisites} from '../../_redux/user/actions';

export default connect(
	(state: IReduxStoreState) => state.user,
	{clearUserRequisites}
)(AuthLogout);
